module.exports = __webpack_public_path__ + "img/CONDONACIONES.8c95bd6e.jpg";